module.exports = __webpack_public_path__ + "static/img/takagi_02.6495158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/takagi_02.png
// module id = DkQf
// module chunks = 0